import React, { useEffect } from "react";
import { PropTypes } from "prop-types";
import { Select } from "..";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchCoursesFilterData } from "../../../redux/actions/contentCoursesActions";

const PackagesFilter = ({ fieldName, packageType }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(fetchCoursesFilterData("all"));
  }, []);

  const {
    coursesFilterData: { contentPackages }
  } = useSelector(state => state.contentCoursesState);

  const menuItems =
    (!!contentPackages &&
      contentPackages.filter(contentPackage => contentPackage.hasAccess)) ||
    [];

  return (
    <Select
      disableUnderline
      name={fieldName}
      menuItems={[
        { value: "", label: t("filterLabels.showAll") },
        ...menuItems
      ]}
      label={t(
        `filterLabels.${
          packageType === "course" ? "contentPackage" : "packageOrManual"
        }`
      )}
    />
  );
};

export default PackagesFilter;

PackagesFilter.propTypes = {
  fieldName: PropTypes.string,
  packageType: PropTypes.string
};

PackagesFilter.defaultProps = {
  fieldName: "contentPackage",
  packageType: "course"
};
